import { useEffect } from 'react';
import { useApiContext, useCurrency, useGetFullInfo, useGetSubscriptions } from 'react-easyrocket';
import { cioIdentify, cioReset } from '../utils';

/** Вызывает cioIdentify для пользователей, которые заходят
 * на сайт уже авторизованными или авторизуются.
 * Вызывает cioReset для пользователей, который разлогиниваются.
 */
export function useSetUserDataToCio() {
  const { isAuthenticated } = useApiContext();
  const { fullInfo, isSuccess: getFullInfoSuccess } = useGetFullInfo();
  const { currencyName, currentBalance } = useCurrency();
  const { isSuccess: getSubscriptionsSuccess, subscriptions } = useGetSubscriptions();

  useEffect(() => {
    if (isAuthenticated && getFullInfoSuccess && currencyName && getSubscriptionsSuccess) {
      cioIdentify({
        id: String(fullInfo.id),
        email: fullInfo.email,
        country: fullInfo.country,
        currency: currencyName,
        language: fullInfo.language,
        // eslint-disable-next-line camelcase
        subscribe_bonuses: Boolean(subscriptions?.email?.bonuses),
        balance: currentBalance
      });
    }
    if (!isAuthenticated) {
      cioReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, getFullInfoSuccess, getSubscriptionsSuccess]);
}
